import { render } from "./custommodal.vue?vue&type=template&id=559f9bc0"
import script from "./custommodal.vue?vue&type=script&lang=js"
export * from "./custommodal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__